/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Create_Criteria_LinkInputs */

const en_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one to start finding matching jobs`)
};

const de_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle eines, um passende Stellen zu finden`)
};

const fr_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crée-en un pour commencer à trouver des emplois correspondants`)
};

const es_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree uno para empezar a encontrar empleos que coincidan`)
};

const it_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creane uno per iniziare a trovare lavori corrispondenti`)
};

const nl_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak er een aan om passende banen te vinden`)
};

const pl_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz jedno, aby zacząć znajdować pasujące oferty`)
};

const fi_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo hakukriteeri aloittaaksesi vastaavien työpaikkojen etsimisen`)
};

const da_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret et for at begynde at finde matchende job`)
};

const sv_jobs_create_criteria_link = /** @type {(inputs: Jobs_Create_Criteria_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ett för att börja hitta matchande jobb`)
};

/**
* | output |
* | --- |
* | "Create one to start finding matching jobs" |
*
* @param {Jobs_Create_Criteria_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_create_criteria_link = /** @type {((inputs?: Jobs_Create_Criteria_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Create_Criteria_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_create_criteria_link(inputs)
	if (locale === "fr") return fr_jobs_create_criteria_link(inputs)
	if (locale === "es") return es_jobs_create_criteria_link(inputs)
	if (locale === "it") return it_jobs_create_criteria_link(inputs)
	if (locale === "nl") return nl_jobs_create_criteria_link(inputs)
	if (locale === "pl") return pl_jobs_create_criteria_link(inputs)
	if (locale === "fi") return fi_jobs_create_criteria_link(inputs)
	if (locale === "da") return da_jobs_create_criteria_link(inputs)
	if (locale === "sv") return sv_jobs_create_criteria_link(inputs)
	return en_jobs_create_criteria_link(inputs)
});